import * as React from 'react';
import {View} from 'react-native';
import {useSelector} from 'react-redux';
import {get} from 'lodash';

import {BonusProgressBarCSB} from '/component/base/BonusProgressBar';
import ListItem from '/component/base/ListItem';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {CoachInfoCard} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {getDateUtilDefaultInstance} from '/util/date.util';

import {styles} from './EligibleClientSupportBonusPlusReportContent.style';

interface RecordData {
  newOrderingEntityCount: number;
  currentDate: string;
  reactivatedOECount: number;
  newOECount: number;
  totalOECount: number;
  eligibleCSBPlusThrough: string;
}

interface EligibleClientSupportBonusPlusReportContentProps {
  recordData: RecordData;
  popoverShow: () => void;
}

export const EligibleClientSupportBonusPlusReportContent: React.FC<
  EligibleClientSupportBonusPlusReportContentProps
> = ({
  recordData = {
    newOrderingEntityCount: 0,
    currentDate: '',
    reactivatedOECount: 0,
    newOECount: 0,
    eligibleCSBPlusThrough: '',
    totalOECount: 0,
  },
  popoverShow = () => {},
}) => {
  const {
    newOrderingEntityCount,
    currentDate,
    newOECount,
    eligibleCSBPlusThrough,
    totalOECount,
    reactivatedOECount,
  } = recordData;

  const featureFlag = useSelector(variablesFeatureFlag);
  const showEnhancedCSBPlus = get(featureFlag, 'showEnhancedCSBPlus', false);
  const {tt} = useTranslation(
    'reportCardContent.eligibleClientSupportBonusPlus',
  );
  return (
    <View style={styles.base}>
      <View style={styles.header}>
        <Gutter>
          <Text variant="heading" testID={CoachInfoCard.eligibleForCSBPTitle}>
            {tt('title', 'Eligible for Client Support Bonus+')}
          </Text>
        </Gutter>
      </View>
      <Gutter>
        <View style={styles.bonusProgressBar}>
          <BonusProgressBarCSB
            newOrderingEntities={newOrderingEntityCount}
            currentDate={currentDate}
            popoverShow={popoverShow}
            currentScreen="Bonus"
            newOECount={newOECount}
            reactivatedOECount={reactivatedOECount}
            totalOECount={totalOECount}
          />
        </View>
      </Gutter>
      {showEnhancedCSBPlus && (
        <Gutter>
          <ListItem
            style={{base: styles.listItem}}
            readonly
            label={<Text>{tt('eligible through', 'Eligible through')}</Text>}
            testID={CoachInfoCard.eligibleThrough}
            suffix={
              <Text variant="button">
                {getDateUtilDefaultInstance().formatDate(
                  eligibleCSBPlusThrough,
                  'MMMM d, yyyy',
                )}
              </Text>
            }
          />
        </Gutter>
      )}
    </View>
  );
};
